export enum PAGES {
	HOME = 'service-history-review',
}

export const REMOTE = {
	NAME: 'service_history_review',
	MANIFEST_PATH: '/remotes/service-history-review/mf-manifest.json',
} as const;
